import { render, staticRenderFns } from "./AddGalery.vue?vue&type=template&id=075bea8c&scoped=true&"
import script from "./AddGalery.vue?vue&type=script&lang=js&"
export * from "./AddGalery.vue?vue&type=script&lang=js&"
import style0 from "./AddGalery.vue?vue&type=style&index=0&id=075bea8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075bea8c",
  null
  
)

export default component.exports